import { BaseController } from '../../common/base/controller';
import _ from 'lodash';

export class PublicController extends BaseController {
  constructor(controllerService, CDN_PATH, CDN_MPATH) {
    'ngInject';
    super({ controllerService, CDN_PATH, CDN_MPATH });
  }

  $onInit() {
    this.pageType = this.$stateParams.pageType;

    let tenant = this.envService.getTenant();
    if (tenant === 'wuestenrotdirect') {
      tenant = this.envService.getCustom();
    }

    let customLinks = this.config.ui.customerEntry.footer.customLinks;
    if (!_.includes(customLinks, this.pageType)) {
      this.pageUrl = `${this.CDN_PATH}/shared/documents/de/${this.pageType}.md`;
    } else {
      this.pageUrl = `${this.CDN_MPATH}/${tenant}/kwh/${this.pageType}.md`;
    }
  }
}
